export default __webpack_public_path__ + "static/media/mining.be7cfab8.svg";